import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import useGetCompanyInfo from "../../../Hooks/useGetCompanyInfo";
import { useWarehouse } from "../../../Providers/WarehouseProvider";
import { LuCopy } from "react-icons/lu";
import useCommonFunctions from "../../Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions";

const ContactSection = () => {
    const { selectedWarehouse } = useWarehouse()
    const { companyInfoData } = useGetCompanyInfo()
    const { handleCopyToClipboard } = useCommonFunctions()

    const email = selectedWarehouse ? (selectedWarehouse.email ? selectedWarehouse.email : companyInfoData.email) : companyInfoData.email
    const phone = selectedWarehouse ? (selectedWarehouse.phone ? selectedWarehouse.phone : companyInfoData.phone) : companyInfoData.phone

    return (
        <>
            <b>W czym możemy pomóc ?</b>
            <div className="row mt-3 mb-3 d-flex align-items-center">
                <div className="col-auto">
                    <div className="contact-section-circle">
                        <MdEmail size={23} color="white" />
                    </div>
                </div>
                <div className="col d-flex flex-column">
                    <span className="light-text-color">Zostaw wiadomość</span>
                    <div className="d-flex align-items-center" onClick={() => handleCopyToClipboard(email)}>
                        <span>{email}</span>
                        <LuCopy className="element-pointer ms-2" color="var(--primary)" size={15} />
                    </div>
                </div>
            </div>
            <div className="row d-flex d-flex align-items-center">
                <div className="col-auto">
                    <div className="contact-section-circle">
                        <FaPhone size={23} color="white" />
                    </div>
                </div>
                <div className="col d-flex flex-column">
                    <span className="light-text-color">Zadzwoń do nas</span>
                    <div className="d-flex align-items-center" onClick={() => handleCopyToClipboard(phone)}>
                        <span>{phone}</span>
                        <LuCopy className="element-pointer ms-2" color="var(--primary)" size={15} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactSection